import type { UUID } from "utils";

export const URL_PARAMS = {
  PREVIEW_ACCOUNT: "preview",
  PREVIEW_TRANSACTION: "transaction",
  CONFIGURE: "configure",
};

export const CONFIGURE_PARAM_VALUES = {
  NOTIFICATIONS: "notifications",
};

const BASE_URL = "/accounts";

export const PAGE_URLS = {
  list: `${BASE_URL}/overview`,
  accounts: `${BASE_URL}`,
  voltAccounts: `${BASE_URL}/volt-accounts`,
  namedAccounts: `${BASE_URL}/named-accounts`,
  connect: `${BASE_URL}/connect`,
  configuration: `${BASE_URL}/configuration`,
  payments: `${BASE_URL}/payments`,
  configurationEdit: `${BASE_URL}/configuration?${URL_PARAMS.CONFIGURE}=${CONFIGURE_PARAM_VALUES.NOTIFICATIONS}`,
  details: `${BASE_URL}/overview/:id`,
  vibans: `${BASE_URL}/overview/:id/vibans`,
  getLinkToAccountDetails: (id: UUID) => `${BASE_URL}/overview/${id}`,
  getLinkToAccountDetailsVibans: (id: UUID) =>
    `${BASE_URL}/overview/${id}/vibans`,
  getLinkToAccountPreview: (id: UUID, params?: string) => {
    if (params) {
      return `${BASE_URL}/overview?${params}&${URL_PARAMS.PREVIEW_ACCOUNT}=${id}`;
    }

    return `${BASE_URL}/overview?${URL_PARAMS.PREVIEW_ACCOUNT}=${id}`;
  },
};
